import React from 'react'
import { ChartContainer } from '../styles'
import { Line } from 'react-chartjs-2'

function InterviewsChart({xData, customer}) {

    const data = {
      labels: xData,
      datasets: [
        {
          label: 'Customer Interviews',
          data: customer,
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          borderColor: 'rgb(255, 99, 132)',
        }
      ],
    }
    
    const options = {
      maintainAspectRatio: false,
      scales: {
        xAxes: [ {
          scaleLabel: {
            display: true,
            labelString: 'Week'
          } 
        } ],
        yAxes: [{
          ticks: {
              beginAtZero: true
          }
        }]
      }
    }

    return(
          <ChartContainer className="chart-container">
              <Line data={data} options={options}/>
          </ChartContainer>
    )
}

export default InterviewsChart